import { Types } from './types'

const initialState = {
    dataHoliday: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const holidayReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_HOLIDAY:
            return {
                ...newState,
                dataHoliday: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return {...newState }
    }
}
export default holidayReducer